import { Link, useSearchParams } from "react-router-dom";

import { buttonVariants } from "@/components/ui/button";
import { cn } from "@/lib/utils";

export function OrdersPagination({
  page,
  pageCount,
  total,
}: {
  page: number;
  pageCount: number;
  total: number;
}) {
  const [params] = useSearchParams();

  function hrefFor(p: number) {
    const next = new URLSearchParams(params);
    if (p <= 1) next.delete("page");
    else next.set("page", String(p));
    const qs = next.toString();
    return qs ? `/admin?${qs}` : "/admin";
  }

  const navLinkClass = (disabled: boolean) =>
    cn(
      buttonVariants({ variant: "outline", size: "sm" }),
      disabled && "pointer-events-none opacity-50",
    );

  const prevDisabled = page <= 1;
  const nextDisabled = page >= pageCount;

  return (
    <div className="flex items-center justify-between gap-4 text-xs text-muted-foreground">
      <span>
        {total} {total === 1 ? "order" : "orders"} · Page {page} of {pageCount}
      </span>
      <div className="flex items-center gap-2">
        <Link
          to={hrefFor(page - 1)}
          aria-disabled={prevDisabled}
          tabIndex={prevDisabled ? -1 : undefined}
          className={navLinkClass(prevDisabled)}
        >
          Previous
        </Link>
        <Link
          to={hrefFor(page + 1)}
          aria-disabled={nextDisabled}
          tabIndex={nextDisabled ? -1 : undefined}
          className={navLinkClass(nextDisabled)}
        >
          Next
        </Link>
      </div>
    </div>
  );
}
